import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { EditorSingleCharacter } from "./EditorSingleCharacter";
import { charEditorStore } from "../../stores/CharacterEditorStore";
import { Popup } from "../shared/Popup";
import { undoableCharacterEditorDeselectCharacter } from "../../stores/undo/operation/CharacterEditorSelectCharacterOp";
import { UiConstants } from "../../data/UiConstants";
import { HeaderUndoRedo } from "../editor/HeaderUndoRedo";
import { PopupAutoScaleContainer } from "../game/PopupAutoScaleContainer";
import { CharacterDeleteButton } from "./CharacterDeleteButton";
import { undoableCharacterEditorDeleteCharacter } from "../../stores/undo/operation/CharacterEditorDeletionOp";
const Content = styled.div.withConfig({
  displayName: "EditorCharacterPopup__Content",
  componentId: "sc-19b2uqr-0"
})(["display:flex;flex-direction:row;border:black 1px solid;gap:10px;background-color:black;color:white;height:100%;"]);
const ButtonContainer = styled.div.withConfig({
  displayName: "EditorCharacterPopup__ButtonContainer",
  componentId: "sc-19b2uqr-1"
})(["display:flex;padding-bottom:10px;"]);
const Spacer = styled.div.withConfig({
  displayName: "EditorCharacterPopup__Spacer",
  componentId: "sc-19b2uqr-2"
})(["width:20px;"]);
export const EditorCharacterPopup = observer(() => {
  if (!charEditorStore.selectedCharacterConfiguration) return null;
  return /*#__PURE__*/React.createElement(Popup, {
    zIndex: UiConstants.Z_INDEX_CHARACTER_EDITOR_POPUP,
    closePopup: () => undoableCharacterEditorDeselectCharacter(charEditorStore)
  }, /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(HeaderUndoRedo, null), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(CharacterDeleteButton, {
    onConfirm: () => undoableCharacterEditorDeleteCharacter(charEditorStore.selectedCharacterConfiguration.id, charEditorStore)
  })), /*#__PURE__*/React.createElement(PopupAutoScaleContainer, {
    width: 1360,
    height: 820,
    staticBorderX: 90,
    staticBorderY: 110,
    percentageBorderX: 0.1,
    percentageBorderY: 0.1
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(EditorSingleCharacter, {
    store: charEditorStore,
    checkUniqueName: true,
    isGame: false
  }))));
});